const allowedRoles = [
	'admin',
	'ai_intelligence_admin',
	'ai_intelligence_create',
	'ai_intelligence_view'
];

const deleteRoles = ['admin', 'ai_intelligence_admin'];

const AIIntelligenceRoles = {
	allowedRoles,
	deleteRoles,
};

export default AIIntelligenceRoles;
